import { SearchesState } from './types'
import { RootState } from '../../reducers'

// Step
function stepSearchSelector(state: RootState): SearchesState['step'] {
  return state.searches.step
}

export function stepSearchQuerySelector(state: RootState) {
  return stepSearchSelector(state).query
}

export function stepSearchFocusSelector(state: RootState) {
  return stepSearchSelector(state).focus
}

// Dialog
export function dialogSearchSelector(state: RootState): SearchesState['dialog'] {
  return state.searches.dialog
}

export function dialogSearchQuerySelector(state: RootState) {
  return dialogSearchSelector(state).query
}

// Media
export function mediaSearchSelector(state: RootState): SearchesState['media'] {
  return state.searches.media
}

export function mediaSearchQuerySelector(state: RootState) {
  return mediaSearchSelector(state).query
}
